import React from 'react';
import {
  Form, FormGroup, Label,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { FormField } from '../../../../../utils/FormFields';

function ShareHoldersTab({
  person,
  changedPerson,
  showChanges,
  edit,
}) {
  const editShareHolder = changedPerson.ShareHolder[0];
  let compareHolder;
  person.ShareHolder.map((s) => {
    if (parseInt(s.ShareHolderId, 10)
      === parseInt(editShareHolder.ShareHolderId, 10)) {
      compareHolder = s;
    }
    return {};
  });
  let color = 'black';
  if (showChanges && editShareHolder.ShareHolderId > 0 && edit) {
    color = '#36a9e1';
  } else if (showChanges && editShareHolder.ShareHolderId > 0 && !edit) {
    color = 'red';
  } else if (showChanges && parseInt(editShareHolder.ShareHolderId, 10) === 0) {
    color = 'green';
  }
  return (
    <Form>
      <Label style={{
        fontWeight: 500, fontSize: '20px', display: 'block', color,
      }}
      >
        {showChanges ? (
          <React.Fragment>
            {editShareHolder.ShareHolderId > 0 && !edit
              ? 'Remove Share Holder'
              : (
                <React.Fragment>
                  {parseInt(editShareHolder.ShareHolderId, 10) === 0 ? 'New Share Holder' : 'Edit Share Holder'}
                </React.Fragment>
              )}
          </React.Fragment>
        ) : 'Actual Account'}
      </Label>
      {showChanges
        ? (
          <FormGroup tag="fieldset">
            {(parseInt(editShareHolder.ShareHolderId, 10) === 0 || edit)
              && <FormToShow shareHolder={editShareHolder} compareHolder={compareHolder} />}
          </FormGroup>
        )
        : (
          <FormGroup tag="fieldset">
            {compareHolder && <FormToShow shareHolder={compareHolder} />}
          </FormGroup>
        )}
    </Form>
  );
}

ShareHoldersTab.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.array,
  showChanges: PropTypes.bool.isRequired,
  edit: PropTypes.bool.isRequired,
};

ShareHoldersTab.defaultProps = {
  changedPerson: undefined,
};

function FormToShow({ shareHolder, compareHolder }) {
  return (
    <React.Fragment>
      <FormField
        label="Person Type: "
        name="ShareHolderPersonType"
        value={shareHolder.ShareHolderPersonType}
        changedColor={compareHolder
          && shareHolder.ShareHolderPersonType !== compareHolder.ShareHolderPersonType}
      />
      <FormField
        label="Person Name: "
        name="ShareHolderPersonId"
        value={shareHolder.ShareHolderPersonName}
        changedColor={compareHolder
          && shareHolder.ShareHolderPersonName
          !== compareHolder.ShareHolderPersonName}
      />
      <FormField
        label="Relationship Description: "
        name="ShareHolderRelationshipDescription"
        value={shareHolder.ShareHolderRelationshipDescription}
        changedColor={compareHolder
          && shareHolder.ShareHolderRelationshipDescription
          !== compareHolder.ShareHolderRelationshipDescription}
      />
      <FormField
        label="Participation Percentage: "
        value={shareHolder.ShareHolderParticipationPercentage}
        name="ShareHolderParticipationPercentage"
        changedColor={compareHolder
          && parseFloat(shareHolder.ShareHolderParticipationPercentage)
          !== parseFloat(compareHolder.ShareHolderParticipationPercentage)}
      />
    </React.Fragment>
  );
}

FormToShow.propTypes = {
  compareHolder: PropTypes.object,
  shareHolder: PropTypes.object.isRequired,
};

FormToShow.defaultProps = {
  compareHolder: undefined,
};

export default (ShareHoldersTab);
